module.exports = __webpack_public_path__ + "static/media/logo-black.42dc0ffb.png";